import { c as _c } from "react/compiler-runtime";
import useMobileLayout from '@/hooks/use-mobile-layout';
import useChatWidgetLayout from './use-chat-widget-layout';
import useChatWidgetLayoutSwitch from './use-chat-widget-layout-switch';
import useChatWidgetLockedFullscreen from './use-chat-widget-locked-fullscreen';
import useChatWidgetOpen from './use-chat-widget-open';

// Keeps the chat open beside a page opened from it. A fullscreen chat, including the one a Percy
// route like `/chat/[id]` shows whatever the stored layout, would cover that page, so on desktop it
// moves to the sidebar.
const useShowChatBeside = () => {
  const $ = _c(6);
  const {
    open
  } = useChatWidgetOpen();
  const {
    mode
  } = useChatWidgetLayout();
  const lockedFullscreen = useChatWidgetLockedFullscreen();
  const switchLayout = useChatWidgetLayoutSwitch();
  const isMobile = useMobileLayout();
  let t0;
  if ($[0] !== isMobile || $[1] !== lockedFullscreen || $[2] !== mode || $[3] !== open || $[4] !== switchLayout) {
    t0 = () => !isMobile && (mode === "fullscreen" || lockedFullscreen) ? switchLayout("sidebar") : open();
    $[0] = isMobile;
    $[1] = lockedFullscreen;
    $[2] = mode;
    $[3] = open;
    $[4] = switchLayout;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export default useShowChatBeside;